module.exports = "/next-static/_next/static/images/hero_image_large-33ab0cb955016eb62959c3b2a732c84e.png";